<template>
  <div>
    <el-table :data='logList'>
      <el-table-column prop='msg' label='操作内容'></el-table-column>
      <el-table-column prop='created_at' label='操作时间' width='160'></el-table-column>
    </el-table>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getPlcItemLog } from '@/api/plc'

export default {
  name: 'PlcCheckLogView',
  props: {
    // 刊例提报ID
    plcItemId: {
      type: [Number, String]
    }
  },
  computed: {
    ...mapGetters(['userPermissions'])

  },
  data() {
    return {
      logList: []
    }
  },
  methods: {
    async getLogs() {
      const { list } = await getPlcItemLog(this.plcItemId)
      this.logList = list || []
    },
    init() {
      this.getLogs()
    }
  },
  mounted() {
    this.init()
  }

}
</script>
<style scoped>

</style>
